
export default function getConfig()
{
    var config = {
        // captcha_site_key : "6LeqORgjAAAAAJvW5P_sLbyPyTtWVrc_Bxmze3GY",
        captcha_site_key : "6LfkNmkrAAAAAPuo9_0JjjbFT8paLrB8lX3mBiup",
        // enrollment_api_url : "https://localhost:44359/api/enrollment/enrollments",
        enrollment_api_url : `${window.location.origin}/api/enrollment/enrollments`,
        // enrollment_api_url : `https://uatpatron.hoiana.com/api/enrollment/enrollments`,

        verify_otp_url: `${window.location.origin}/api/enrollment/enrollments/verify-otp`,
        // verify_otp_url: `https://localhost:44359/api/enrollment/enrollments/verify-otp`,

        snackbar_span : 6000
    }

    return config;
}